import type { AnnotatedJsonSchema } from '@web-config-app/core';

export const isCombinatorSchema = ({
  anyOf,
  oneOf,
  allOf,
}: AnnotatedJsonSchema) => Boolean(anyOf || oneOf || allOf);
